import { h as r } from "vue";
import { renderAvatar as l } from "./ghl-ui.es704.js";
const a = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  marginLeft: "8px",
  padding: "4px 0px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, s = (e) => r(
  "div",
  {
    style: {
      display: "flex",
      alignItems: "center"
    }
  },
  [
    l(e),
    r(
      "div",
      {
        style: a
      },
      [
        r(
          "p",
          {
            style: {
              margin: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }
          },
          [e.label]
        ),
        r(
          "span",
          {
            style: {
              color: e.disabled ? "var(--gray-300)" : "var(--gray-500)"
            }
          },
          {
            default: () => e == null ? void 0 : e.description
          }
        )
      ]
    )
  ]
);
export {
  s as renderLabelAsAvatar
};
